var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-flex-col lg:tw-flex-row lg:tw-justify-end lg:tw-space-x-5 tw-space-y-5 lg:tw-space-y-0"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }